/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallEnd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13.428 8c1.983 0 3.868.405 5.52 1.23 2.406 1.204 3.943 3.011 4.046 5.5L23 15v.414l-3.906 3.906L14 15.5v-5.485l-.185-.009-.387-.006h-2.856c-.13 0-.259.002-.387.006l-.185.009V15.5l-5.094 3.82L1 15.414V15c0-2.629 1.56-4.523 4.053-5.77 1.533-.766 3.268-1.17 5.096-1.224L10.572 8zM8 10.286l-.04.01c-.71.168-1.385.41-2.013.723-1.643.822-2.663 1.912-2.896 3.337l-.032.248 2.075 2.075L8 14.499zm8 0v4.213l2.906 2.179 2.074-2.074-.002-.031c-.154-1.463-1.107-2.585-2.694-3.434l-.231-.12a9.155 9.155 0 0 0-1.59-.614z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallEnd as CallEnd };
